/**
 * *************************************************************************************************************************
 * Responsibility - Displays a table with all the charges and triggers an action that allows the user to pay them singularly
 * or in multiplicity. All logic is abstracted to its respective hook.
 * *******************************************************************
 *
 * @format
 */

import withPaymentsHandler from '../with_payments_handler';
import {CartRelatedOrders} from '../cart_related_orders';
import {useTableSort} from '../use_table_sort';
import NumberFormat from 'react-number-format';
import {PayCharge} from './pay_charge';
import {If} from 'frontier-utilities';
import React, {useState} from 'react';
import Moment from 'moment/moment';

export const Charges = withPaymentsHandler(props => {
    const {handleToggleModal, charges} = props;

    const {sortedData, sortColumn, sortOrder, toggleSort} = useTableSort(charges);

    return (
        <If condition={charges.length > 0}>
            <PayCharge {...props} />
            <div className="invoices-09ka__responsive-table">
                <table cellSpacing="0" width="100%" className="all-invoices-09ka__table">
                    <thead>
                        <tr>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => toggleSort('invoiceId')}>
                                    <h5 className="m-0">Invoice #</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'invoiceId'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                            <th>
                                <h5>Related Order #</h5>
                            </th>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-cente gap-2"
                                    onClick={() => toggleSort('due')}>
                                    <h5 className="m-0">Due</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'due'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                            <th>
                                <div
                                    className="d-flex align-items-center justify-content-cente gap-2"
                                    onClick={() => toggleSort('amount')}>
                                    <h5 className="m-0">Amount</h5>
                                    <i
                                        style={{fontSize: '12px'}}
                                        className={`fa ${
                                            sortColumn === 'amount'
                                                ? sortOrder === 'asc'
                                                    ? 'fa-caret-up'
                                                    : 'fa-caret-down'
                                                : 'fa-filter'
                                        }`}></i>
                                </div>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((chargeBatch, i) => {
                            const invoiceDue = Moment(chargeBatch.shipped_time).add(30, 'days');
                            const isOverdue = invoiceDue.unix() < Moment().unix();

                            return (
                                <tr key={chargeBatch.id}>
                                    <td className="action-link-cell">
                                        <div>
                                            <i className={'fa fa-eye'}></i>
                                            {/* TODO: I need to send the addresses from our BE endpoint render preview*/}
                                            {/*<Link to={`/account/charges/index/${chargeBatch.id}`}>*/}
                                            {/*    {chargeBatch.id}*/}
                                            {/*</Link>*/}
                                            <u>
                                                <a
                                                    href={`/account/charge-batches/preview/${chargeBatch.id}`}
                                                    rel={'noopener noreferrer'}
                                                    target="_blank">
                                                    {chargeBatch.id}
                                                </a>
                                            </u>
                                        </div>
                                    </td>
                                    <td>
                                        <CartRelatedOrders
                                            orders={chargeBatch.cart.orders}
                                            poNumber={chargeBatch.cart.po_number}
                                        />
                                    </td>
                                    <td>
                                        <p>
                                            {isOverdue ? (
                                                <b className={'color-alert-negative'}>
                                                    {invoiceDue.format('MM/DD/YY')}
                                                </b>
                                            ) : (
                                                invoiceDue.format('MM/DD/YY')
                                            )}
                                        </p>
                                    </td>
                                    <td>
                                        {isOverdue ? (
                                            <b className={'color-alert-negative'}>
                                                <NumberFormat
                                                    value={
                                                        chargeBatch.total -
                                                        chargeBatch.partial_payments
                                                    }
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    decimalScale={2}
                                                    prefix={'$'}
                                                />
                                            </b>
                                        ) : (
                                            <NumberFormat
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                value={chargeBatch.total}
                                                displayType="text"
                                                decimalScale={2}
                                                prefix={'$'}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        <button
                                            className="d-flex align-items-center justify-content-start gap-3"
                                            onClick={() =>
                                                handleToggleModal('charges', chargeBatch.id)
                                            }>
                                            <i className="fa-solid fa-dollar-sign color-accent-primary" />
                                            <b className="color-accent-primary">Pay</b>
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </If>
    );
});
